import { usePositioning } from '@fluentui/react-positioning';
import type { UserMessageProps } from '../components/UserMessage/UserMessage.types';
import type { PositioningShorthandValue } from '@fluentui/react-components';

export function useUserMessagePositioning(props: UserMessageProps): [
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actionBarRef: React.MutableRefObject<any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  triggerRef: React.MutableRefObject<any>,
] {
  // Set a default set of fallback positions to try if the dropdown does not fit on screen
  const fallbackPositions: PositioningShorthandValue[] = ['below-end', 'after', 'after-top', 'before', 'before-top'];

  const popperOptions = {
    position: 'above' as const,
    align: 'end' as const,
    offset: { crossAxis: 0, mainAxis: 2 },
    fallbackPositions,
    autoSize: true,
  };

  const { targetRef, containerRef } = usePositioning(popperOptions);

  return [containerRef, targetRef];
}
